import { FullWidthSpace } from "melco-ui";
import { ThreadProductList } from "../ThreadProductList";

type ThreadProductsTabProps = {
}


export const ThreadProductsTab: React.FC<ThreadProductsTabProps> = () => {


    return <>



        <FullWidthSpace size="small" direction="vertical">
            <ThreadProductList />
        </FullWidthSpace>

    </>
}